import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-25a22e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "p_brand_video_div" }
const _hoisted_2 = ["poster"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { id: "p_brand_video_box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "p_brand_video_icon",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      id: "c_video",
      controls: "",
      name: "media",
      poster: _ctx.data.poster
    }, [
      _createElementVNode("source", {
        src: _ctx.data.videoURL,
        type: "video/mp4"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.words, (word, index) => {
        return (_openBlock(), _createElementBlock("div", {
          id: "p_brand_video_des",
          key: index
        }, _toDisplayString(word), 1))
      }), 128))
    ])
  ]))
}